export default "__VITE_ASSET__19de1172__"